import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Check, Sparkles, Zap, Crown, Rocket } from "lucide-react";

export const PLANS = [
  {
    id: "basic",
    name: "Plan Básico",
    price: "9,99€",
    quota: 1,
    icon: Zap,
    features: ["Publica 1 anuncio al mes", "Soporte estándar", "Cancela cuando quieras"],
    highlight: false,
  },
  {
    id: "advanced",
    name: "Plan Avanzado",
    price: "29,99€",
    quota: 4,
    icon: Rocket,
    features: ["Publica 4 anuncios al mes", "Mayor visibilidad", "Soporte prioritario"],
    highlight: true,
  },
  {
    id: "premium",
    name: "Plan Premium",
    price: "49,99€",
    quota: 10,
    icon: Crown,
    features: ["Publica 10 anuncios al mes", "Máxima visibilidad", "Soporte VIP"],
    highlight: false,
  },
] as const;

const PricingPlans = () => {
  return (
    <section className="relative overflow-hidden border-b border-border py-16">
      <div className="container relative">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full border border-primary/30 bg-primary/10 px-3 py-1 text-xs font-semibold text-primary">
            <Sparkles className="h-3.5 w-3.5" /> Planes de suscripción
          </span>
          <h2 className="mt-4 font-display text-3xl font-bold tracking-tight md:text-4xl">
            Elige el plan que{" "}
            <span className="bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
              mejor se adapte
            </span>
          </h2>
           <p className="mt-3 text-muted-foreground">
             Suscríbete desde solo <span className="font-semibold text-foreground">9,99 €/mes</span> y publica tus anuncios sin pagar comisiones por venta.
           </p>
        </div>

        <div className="mt-10 grid gap-6 md:grid-cols-3">
          {PLANS.map((plan) => {
            const Icon = plan.icon;
            return (
              <Card
                key={plan.id}
                className={`relative overflow-hidden transition-all hover:-translate-y-1 hover:shadow-2xl ${
                  plan.highlight ? "border-primary/60 shadow-lg shadow-primary/20" : ""
                }`}
              >
                {plan.highlight && (
                  <div className="absolute right-4 top-4 rounded-full bg-gradient-to-r from-primary to-accent px-3 py-1 text-xs font-bold text-primary-foreground">
                    Más popular
                  </div>
                )}
                <CardHeader>
                  <div className="mb-2 flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-primary/20 to-accent/20">
                    <Icon className="h-6 w-6 text-primary" />
                  </div>
                  <CardTitle className="font-display text-2xl">{plan.name}</CardTitle>
                  <CardDescription>
                    <span className="text-3xl font-bold text-foreground">{plan.price}</span>
                    <span className="text-sm">/mes</span>
                  </CardDescription>
                </CardHeader>
                <CardContent className="space-y-4">
                  <ul className="space-y-2">
                    {plan.features.map((f) => (
                      <li key={f} className="flex items-start gap-2 text-sm">
                        <Check className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
                        <span>{f}</span>
                      </li>
                    ))}
                  </ul>
                  <Button
                    asChild
                    className={`w-full ${
                      plan.highlight
                        ? "bg-gradient-to-r from-primary to-accent shadow-md shadow-primary/30"
                        : ""
                    }`}
                    variant={plan.highlight ? "default" : "outline"}
                  >
                    <Link to={`/registro?plan=${plan.id}`}>Elegir {plan.name}</Link>
                  </Button>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default PricingPlans;